import React, { Component } from 'react';
import { connect } from 'shalala';
import { Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import './Sidebar.css';

import { useStore } from '../store';
import { Auth, Event } from '../support';
import PageError403 from '../shared/errors/PageError403';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import ReceptorAppSidebar from './sidebar/ReceptorAppSidebar';
import Facturas from '../external/receptores/comprobantes/Comprobantes';
import ReceptorProfile from '../external/receptores/perfil/ReceptorProfile';
import FacturasInfo from '../external/receptores/comprobantes/ComprobantesInfo';
import Autofacturacion from '../external/receptores/autofacturacion/Autofacturacion';
import NavBarReceptoresHeader from './components/navbar-header/NavBarReceptoresHeader';
import AutofacturacionTicketInfo from '../external/receptores/autofacturacion/AutofacturacionTicketInfo';
import AutofacturacionTicketTimbradoRequest from '../external/receptores/autofacturacion/AutofacturacionTicketTimbradoRequest';

class ReceptorAppLayout extends Component {
  notification = null;

  state = {
    open: false,
    live: false,
  };

  _mounted = false;

  constructor(props) {
    super(props);

    const { user = {} } = Auth.getData() || {};

    this.state = {
      open: false,
      live: user.live || false,
    };

    this.setTenancy(user.live || false);

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  handleDrawerNeedsClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOnAppNeedsRefresh = () => {
    const { user = {} } = Auth.getData() || {};

    this.setState({
      live: user.live || false,
    });
  };

  setTenancy = (live) => {
    this.props.tenantActions.setPartialState({ data: { live } });
  };

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.open;

    this.setState({
      open: state,
    });
  };

  render() {
    const { open } = this.state;
    const {
      busy,
      data: { live = false },
    } = this.props.tenant;

    const sidebarClassName = !!open ? 'sidebar-open' : '';

    if (!Guardian.allows('external.access')) {
      return <PageError403 />;
    }

    return (
      <Container
        fluid={true}
        className={`app-wrapper ${sidebarClassName}`}
      >
        <NavBarReceptoresHeader
          fluid={false}
          onToggleSidebar={this.handleOnToggleSidebar}
        />

        <HttpErrorMonitor />

        <div
          className="sidebar-backdrop"
          onClick={this.handleOnToggleSidebar.bind(this, false)}
        ></div>

        <div className="d-block d-lg-none d-xl-none">
          <ReceptorAppSidebar
            live={live}
            open={open}
            busy={busy}
            onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
          />
        </div>

        <div className="app-container container">
          <div className="d-none d-lg-flex d-xl-flex">
            <ReceptorAppSidebar
              live={live}
              open={open}
              busy={busy}
              onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
            />
          </div>

          <div className="main-container">
            <div className="page-container">
              <Route
                path="/ext/receptores/autofacturacion/tickets"
                component={Autofacturacion}
                exact
              />
              <Route
                path="/ext/receptores/autofacturacion/tickets/:id/info"
                component={AutofacturacionTicketInfo}
                exact
              />
              <Route
                path="/ext/receptores/autofacturacion/tickets/facturar"
                component={AutofacturacionTicketTimbradoRequest}
                exact
              />

              <Route
                path="/ext/receptores/facturas"
                component={Facturas}
                exact
              />
              <Route
                path="/ext/receptores/perfil"
                component={ReceptorProfile}
                exact
              />
              <Route
                path="/ext/receptores/facturas/:uuid/info"
                component={FacturasInfo}
                exact
              />
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapState = (store) => {
  return { tenant: store.layouts.empresa.tenant };
};

const mapActions = (actions) => {
  return { tenantActions: actions.layouts.empresa.tenant };
};

export default connect(useStore, mapState, mapActions)(ReceptorAppLayout);
